import Link from "next/link";
import { Button, Tooltip, theme, Typography } from "antd";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CloseOutlined,
  ExportOutlined,
  LinkOutlined,
} from "@ant-design/icons";
import { Flex } from "src/components/Flex";
import { useOrg } from "src/hooks/useOrg";
import { useEntityContext } from "../useEntityContext";
import { AddToSpacePicker } from "pages/[orgId]/space/AddToSpacePicker";
import { SpaceItemType } from "pages/api/[orgId]/spaces/types";
import { ItemTypeIcon } from "src/components/icons/ItemTypeIcon";
import { ItemType } from "src/components/useLibrary";

const nameProps: { [key: string]: string } = {
  Issue: "issueKey",
  PullRequest: "title",
  Commit: "message",
};
const getName = (entity: any) => {
  const label = entity?.labels[0];
  const nameProp: string = nameProps[label] || "name";
  return entity?.properties[nameProp];
};

export const TopNav = (props: { close: () => void }) => {
  const { token } = theme.useToken();
  const orgId = useOrg().id;
  const { query, forward, back, hasForward, hasBack } = useEntityContext();
  const uuid = query.data?.entity?.properties?.uuid;
  const copyPath = uuid ? `/${orgId}/entity/${uuid}` : undefined;
  const copyUrl = uuid ? `${location.origin}${copyPath}` : undefined;
  const hrefObj =
    uuid && copyUrl
      ? {
          pathname: `/[orgId]/t/new`,
          query: {
            orgId,
            url: copyPath,
            title: getName(query.data?.entity) || `entity #${uuid}`,
          },
        }
      : undefined;
  return (
    <Flex spaceBetween style={{ width: "100%" }}>
      <Flex>
        <Flex style={{ marginRight: 12 }}>
          <Tooltip title="Go Back">
            <Button
              type="text"
              onClick={back}
              disabled={!hasBack}
              style={{ border: 0, padding: "4px 8px" }}
            >
              <ArrowLeftOutlined />
            </Button>
          </Tooltip>
          <Tooltip title="Go Forward">
            <Button
              type="text"
              onClick={forward}
              disabled={!hasForward}
              style={{ border: 0, padding: "4px 8px" }}
            >
              <ArrowRightOutlined />
            </Button>
          </Tooltip>
        </Flex>
        <div
          className="section-header trunc"
          style={{
            color: token.colorTextBase,
            maxWidth: "400px",
          }}
        >
          <Tooltip title={uuid}>{getName(query.data?.entity)}</Tooltip>
        </div>
      </Flex>
      <Flex centered style={{ paddingRight: 16, paddingTop: 8 }}>
        <AddToSpacePicker
          item={{
            name: getName(query.data?.entity) || `entity #${uuid}`,
            type: SpaceItemType.Entity,
            config: { entity_uuid: uuid },
          }}
        >
          <Tooltip title="Add to space" mouseEnterDelay={1}>
            <Button type="text" shape="circle" size="small">
              <ItemTypeIcon type={ItemType.SPACES} />
            </Button>
          </Tooltip>
        </AddToSpacePicker>
        {hrefObj && (
          <Tooltip title="Open in new tab" mouseEnterDelay={1}>
            <Link href={hrefObj}>
              <Button size="small" type="text" shape="circle">
                <ExportOutlined style={{ fontSize: 12 }} />
              </Button>
            </Link>
          </Tooltip>
        )}
        {hrefObj && (
          <div style={{ marginRight: 6 }}>
            <Button size="small" type="text" shape="circle">
              <Typography.Link
                copyable={{
                  text: copyUrl,
                  icon: <LinkOutlined style={{ fontSize: 12 }} />,
                }}
                ellipsis
                style={{ color: "green" }}
              ></Typography.Link>
            </Button>
          </div>
        )}
        <Tooltip title="Close" mouseEnterDelay={1}>
          <Button
            size="small"
            type="text"
            shape="circle"
            onClick={props.close}
            icon={<CloseOutlined style={{ fontSize: 12 }} />}
          />
        </Tooltip>
      </Flex>
    </Flex>
  );
};
